module.exports = __webpack_public_path__ + "c6af3eb72b81123ac566d46d5cc74891.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/post-img.png
// module id = 500
// module chunks = 0